import { cn } from '@ui/lib/utils';
import Image from 'next/image';

export default function Logo({ className = '' }: { className?: string }) {
  return <Image src={'/logo.svg'} alt={'hirebetter logo'} height={200} width={1000} aria-label="hirebetter Logo" className={cn('w-56', className)} />;
}
